import { render, staticRenderFns } from "./carrierType.vue?vue&type=template&id=300cf7db&scoped=true&"
import script from "./carrierType.vue?vue&type=script&lang=js&"
export * from "./carrierType.vue?vue&type=script&lang=js&"
import style0 from "./carrierType.vue?vue&type=style&index=0&id=300cf7db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "300cf7db",
  null
  
)

export default component.exports